import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PointSVG from './images/point.svg';
import LineStringSVG from './images/line.string.svg';
import PolygonSVG from './images/polygon.svg';
import { IconButton, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Tooltip, } from '@mui/material';
import { Create, Delete } from '@mui/icons-material';
import * as React from 'react';
import { GeozoneTypes } from '../../model/types';
import { assertNever } from 'utils';
function getIcon(type, color) {
    switch (type) {
        case GeozoneTypes.Point:
            return (_jsx(PointSVG, { width: 32, height: 32, viewBox: "0 0 36 36", style: { color, stroke: color } }));
        case GeozoneTypes.Polygon:
            return (_jsx(PolygonSVG, { width: 32, height: 32, viewBox: "0 0 36 36", style: { color, stroke: color } }));
        case GeozoneTypes.LineString:
            return (_jsx(LineStringSVG, { width: 32, height: 32, viewBox: "0 0 36 36", style: { color, stroke: color } }));
        default:
            return assertNever(type);
    }
}
export function GeozoneListItem(props) {
    const { index, type, color, onChangeIndex, name, onOpenProperties, onDelete } = props;
    const onChange = () => onChangeIndex(index);
    const onOpenGeozoneProperties = () => {
        onOpenProperties(index);
    };
    const onDeleteGeozone = () => {
        onDelete(index);
    };
    return (_jsx(Tooltip, { title: 'Показать на карте геозону ' + name, children: _jsxs(ListItem, { button: true, onClick: onChange, children: [_jsx(ListItemIcon, { children: getIcon(type, color) }), _jsx(ListItemText, { primary: name, primaryTypographyProps: {
                        noWrap: true,
                    }, style: {
                        maxHeight: '25px',
                        marginRight: '58px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    } }), _jsxs(ListItemSecondaryAction, { children: [_jsx(Tooltip, { title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0433\u0435\u043E\u0437\u043E\u043D\u0443", children: _jsx(IconButton, { onClick: onOpenGeozoneProperties, size: "large", children: _jsx(Create, {}) }) }), _jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0433\u0435\u043E\u0437\u043E\u043D\u0443", children: _jsx(IconButton, { onClick: onDeleteGeozone, size: "large", children: _jsx(Delete, {}) }) })] })] }) }));
}
